import { create } from 'zustand';

interface CreateChecklistStore {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

const useCreateChecklistModal = create<CreateChecklistStore>(set => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
}));

export default useCreateChecklistModal;
